// bookingページ: StayNaviフォームのサブミットの定義
if (document.querySelector('[data-role="booking-form"]') !== null) {
  document.querySelectorAll('[data-role="booking-filter-btn"]').forEach((elm) => {
    const input = elm.querySelector('input');
    input.addEventListener('click', (e) => {
      if (elm.classList.contains('is-active')) {
        elm.classList.remove('is-active');
      } else {
        elm.classList.add('is-active');
      }
    });
  });

  document.querySelector('[data-role="booking-submit"]').addEventListener('click', (e) => {
    // Formより参照した値を利用
    const url = document.bookingForm.action;
    const prefVal = document.bookingForm.pf.value;
    const areaVal = document.bookingForm.ar.value;
    const numberOfPeopleVal = document.bookingForm.cp.value;
    const numberOfRoomVal = document.bookingForm.rn.value;
    const minBudgetVal = document.bookingForm.pn.value;
    const maxBudgetVal = document.bookingForm.px.value;
    const roomTypeVal = document.bookingForm.rt.value;
    const mealTypeVal = document.bookingForm.mc.value;
    const keywordsVal = document.bookingForm.kw.value;

    // Formから参照した値を加工し利用
    const dateVal = document.bookingForm.sd.value.replace(/-/g, '');
    // const kodawariNodes = document.bookingForm.kd;
    // const kodawariVals = [];
    // Array.prototype.slice.call(kodawariNodes, 0).forEach((node) => {
    //   if (node.checked) kodawariVals.push(node.value);
    // });

    let baseQuery = `pf=${prefVal}&ar=${areaVal}&sd=${dateVal}&cp=${numberOfPeopleVal}&rn=${numberOfRoomVal}&pn=${minBudgetVal}&px=${maxBudgetVal}&rt=${roomTypeVal}&mc=${mealTypeVal}&kw=${keywordsVal}`;

    const ft2 = document.bookingForm.ft2; // ホテル
    const ft3 = document.bookingForm.ft3; // 旅館
    const bath = document.bookingForm.bath; // 温泉
    const pa1 = document.bookingForm.pa1; // 禁煙ルーム

    const kodawariCheckboxes = [ft2, ft3, bath, pa1];

    // クエリ用のカスタムキーを定義
    const queryKeys = {
      ft2: "facility_type[]",
      ft3: "facility_type[]",
      bath: "bath[]",
      pa1: "plan_attribute[]"
    };

    let queryParams = [];

    function updateQuery() {
      queryParams = []; // 既存のリストをリセット
  
      kodawariCheckboxes.forEach(checkbox => {
        if (checkbox.checked) {
          const key = queryKeys[checkbox.name]; // name に対応するクエリキーを取得
          if (key) {
            queryParams.push(`${key}=${checkbox.value}`);
          }
        }
      });
    }

    // 初回のチェックボックス状態を取得
    updateQuery();

    kodawariCheckboxes.forEach(checkbox => {
      checkbox.addEventListener("change", updateQuery);
    });

    // ボタンクリック時の処理
    e.preventDefault();

    // クエリ文字列を組み立て
    let finalQuery = baseQuery;
    if (queryParams.length) {
      finalQuery += `&${queryParams.join("&")}`;
    }

    const requestURL = `${url}?${finalQuery}`;

    // debug
    // console.log(requestURL);

    // window.location.href = requestURL;
    window.open(requestURL, '_blank');
    return false;
  });
}
